(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initBanner(sectionId) {
      var track = document.getElementById('banner-track-' + sectionId);
      if (!track) return;

      var slides = track.querySelectorAll('.banner__slide');
      var indicators = document.getElementById('banner-indicators-' + sectionId);
      var dots = indicators ? indicators.querySelectorAll('.banner__dot') : [];
      var prevBtn = document.getElementById('banner-prev-' + sectionId);
      var nextBtn = document.getElementById('banner-next-' + sectionId);

      if (slides.length <= 1) return;

      var current = 0;
      var autoplayInterval = null;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function startAutoplay() {
        autoplayInterval = setInterval(function() { goTo(current + 1); }, 5000);
      }

      function resetAutoplay() {
        clearInterval(autoplayInterval);
        startAutoplay();
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); resetAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); resetAutoplay(); });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          goTo(parseInt(dot.dataset.index));
          resetAutoplay();
        });
      });

      var touchStartX = 0;
      track.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      track.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 40) return;
        if (diff > 0) { goTo(current + 1); } else { goTo(current - 1); }
        resetAutoplay();
      }, { passive: true });

      startAutoplay();
    }

    document.querySelectorAll('.banner').forEach(function(el) {
      var id = el.id.replace('banner-', '');
      initBanner(id);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["careers-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MAX_SIZE_MB = 5;
    var MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
    var ALLOWED_TYPES = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ];
    var ALLOWED_EXTS = /\.(pdf|doc|docx)$/i;

    var fileInput = document.getElementById('CareersFormResume');
    var fileWrap  = document.getElementById('CareersFileWrap');
    var fileText  = document.getElementById('CareersFileText');
    var fileError = document.getElementById('CareersFileError');
    var hiddenField = document.getElementById('CareersResumeData');

    if (!fileInput) return;

    fileInput.addEventListener('change', function () {
      var file = fileInput.files[0];

      fileWrap.classList.remove('careers-form__file-wrap--selected', 'careers-form__file-wrap--error');
      fileError.textContent = '';
      hiddenField.value = '';

      if (!file) {
        fileText.textContent = fileInput.getAttribute('data-placeholder') || 'Choose a file';
        return;
      }

      var extOk  = ALLOWED_EXTS.test(file.name);
      var typeOk = ALLOWED_TYPES.indexOf(file.type) !== -1 || file.type === '';

      if (!extOk || (!typeOk && file.type !== '')) {
        fileWrap.classList.add('careers-form__file-wrap--error');
        fileError.textContent = 'Only PDF, DOC, or DOCX files are accepted.';
        fileInput.value = '';
        return;
      }

      if (file.size > MAX_SIZE_BYTES) {
        fileWrap.classList.add('careers-form__file-wrap--error');
        fileError.textContent = 'File is too large. Maximum size is ' + MAX_SIZE_MB + ' MB.';
        fileInput.value = '';
        return;
      }

      fileWrap.classList.add('careers-form__file-wrap--selected');
      fileText.textContent = file.name;

      var reader = new FileReader();
      reader.onload = function (e) {
        hiddenField.value = file.name + '::' + e.target.result;
      };
      reader.readAsDataURL(file);
    });

    var form = fileInput.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (fileInput.files[0] && !hiddenField.value) {
          e.preventDefault();
          fileError.textContent = 'Please wait — the file is still being processed.';
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var moneyFormat = (document.getElementById('cart-money-format') || {}).dataset.format || '{{amount}}';

    function formatMoney(cents) {
      var value = cents / 100;
      var amount = value.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var amountNoDecimals = Math.floor(value).toLocaleString('en-IN');
      var amountWithComma = amount.replace('.', ',');
      var amountNoDecimalsWithComma = amountNoDecimals.replace('.', ',');
      return moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', amountNoDecimals)
        .replace('{{amount_with_comma_separator}}', amountWithComma)
        .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsWithComma);
    }

    function updateItems(updates) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { return r.json(); });
    }

    function removeOrphanedAddons(cart) {
      var allKeys = {};
      cart.items.forEach(function(i) { allKeys[i.key] = true; });
      var orphans = {};
      cart.items.forEach(function(item) {
        var linked = (item.properties || {})['_linked_item'];
        if (linked && !allKeys[linked]) orphans[item.key] = 0;
      });
      if (!Object.keys(orphans).length) return Promise.resolve(cart);
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: orphans })
      }).then(function(r) { return r.json(); });
    }

    function updateCart(key, quantity) {
      var itemEl = document.querySelector('.cart-item[data-key="' + key + '"]');
      if (itemEl) itemEl.classList.add('is-loading');

      var updates = {};
      updates[key] = quantity;

      /* Also zero out the addon if removing the parent */
      var addonKey = itemEl && itemEl.dataset.addonKey;
      if (quantity === 0 && addonKey) updates[addonKey] = 0;

      updateItems(updates)
        .then(function(cart) { return removeOrphanedAddons(cart); })
        .then(function (cart) {
          var subtotalEl = document.getElementById('cart-subtotal');
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

          if (quantity === 0) {
            if (itemEl) itemEl.remove();
            if (cart.item_count === 0) { location.reload(); return; }
          } else {
            if (itemEl) {
              var qtyEl = itemEl.querySelector('.cart-item__qty-input');
              if (qtyEl) qtyEl.textContent = quantity;

              var updatedItem = cart.items.find(function (i) { return i.key === key; });
              if (updatedItem) {
                var priceEl = itemEl.querySelector('[data-line-price]');
                if (priceEl) priceEl.textContent = formatMoney(updatedItem.final_line_price);
              }
              itemEl.classList.remove('is-loading');
            }
          }

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .catch(function () {
          if (itemEl) itemEl.classList.remove('is-loading');
        });
    }

    document.addEventListener('click', function (e) {
      var item = e.target.closest('.cart-item');
      if (!item) return;
      var key = item.dataset.key;

      if (e.target.closest('.js-remove')) {
        updateCart(key, 0);
        return;
      }

      var qtyEl = item.querySelector('.cart-item__qty-input');
      var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;

      if (e.target.closest('.js-qty-minus')) {
        updateCart(key, Math.max(0, current - 1));
      } else if (e.target.closest('.js-qty-plus')) {
        updateCart(key, current + 1);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    /* ── Read more ── */
    var readMoreBtn = document.getElementById('collection-read-more');
    var descEl = document.getElementById('collection-desc');
    if (readMoreBtn && descEl) {
      readMoreBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var expanded = descEl.classList.toggle('is-expanded');
        readMoreBtn.textContent = expanded ? 'Read less' : 'Read more';
        readMoreBtn.setAttribute('aria-expanded', expanded);
      });
    }

    /* ── Facet accordion ── */
    document.querySelectorAll('.facet-group__toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !expanded);
        var body = document.getElementById(btn.getAttribute('aria-controls'));
        if (body) body.classList.toggle('is-collapsed', expanded);
      });
    });

    /* ── Price form: submit as URL params ── */
    var priceForm = document.getElementById('facet-price-form');
    if (priceForm) {
      priceForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var url = new URL(window.location.href);
        var min = document.getElementById('price-min').value;
        var max = document.getElementById('price-max').value;
        if (min) url.searchParams.set('filter.v.price.gte', min); else url.searchParams.delete('filter.v.price.gte');
        if (max) url.searchParams.set('filter.v.price.lte', max); else url.searchParams.delete('filter.v.price.lte');
        window.location.href = url.toString();
      });
    }

    /* ── Cart ── */
    var cartVariantIds = [];

    function syncCartState() {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          cartVariantIds = cart.items.map(function(i) { return String(i.variant_id); });
          document.querySelectorAll('.collection-page .product-list__item[data-variant-id]').forEach(function(card) {
            var variantId = card.dataset.variantId;
            var inCart = cartVariantIds.indexOf(variantId) !== -1;
            var iconBtn = card.querySelector('.product-card-actions__btn--cart');
            var mobileBtn = card.querySelector('.product-card-mobile-bar__cart');
            if (iconBtn) iconBtn.classList.toggle('is-added', inCart);
            if (mobileBtn) {
              mobileBtn.classList.toggle('is-added', inCart);
              if (inCart) mobileBtn.textContent = 'ADDED TO CART';
              else mobileBtn.textContent = mobileBtn.dataset.label || 'ADD TO CART';
            }
          });
        });
    }

    /* ATC form submit — intercept for AJAX + spinner */
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('.collection-page .product-card-atc-form:not(.product-card-atc-form--mobile)');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('.product-card-actions__btn--cart');
      var variantId = form.querySelector('input[name="id"]').value;
      if (!btn || btn.classList.contains('is-loading')) return;

      btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        btn.classList.remove('is-loading');
        if (data.id) {
          btn.classList.add('is-added');
          cartVariantIds.push(String(variantId));
          var mobileBtn = form.closest('.product-list__item').querySelector('.product-card-mobile-bar__cart');
          if (mobileBtn) { mobileBtn.classList.add('is-added'); mobileBtn.textContent = 'ADDED TO CART'; }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(function() { btn.classList.remove('is-loading'); });
    });

    /* Mobile ATC button — submits the hidden form outside the <a> */
    function bindMobileAtc(root) {
      root.querySelectorAll('.product-list__item').forEach(function(card) {
        var mobileAtcBtn = card.querySelector('.js-mobile-atc');
        if (!mobileAtcBtn || mobileAtcBtn.dataset.bound) return;
        mobileAtcBtn.dataset.bound = '1';
        mobileAtcBtn.dataset.label = mobileAtcBtn.textContent.trim();
        mobileAtcBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var hiddenForm = card.querySelector('.product-card-atc-form--mobile');
          if (hiddenForm) hiddenForm.querySelector('[type="submit"]').click();
        });
      });
    }
    bindMobileAtc(document);

    document.addEventListener('cart:refresh', syncCartState);
    syncCartState();

    // ── Load more ──
    var loadMoreWrap = document.querySelector('.collection-page__load-more');
    var loadMoreBtn = document.querySelector('.js-load-more');
    var productGrid = document.querySelector('.collection-page__grid');

    if (loadMoreBtn && productGrid) {
      var loadMoreLabel = loadMoreBtn.dataset.label || loadMoreBtn.textContent.trim();

      loadMoreBtn.addEventListener('click', function() {
        var nextUrl = loadMoreBtn.dataset.nextUrl;
        if (!nextUrl || loadMoreBtn.disabled) return;

        loadMoreBtn.disabled = true;
        loadMoreBtn.textContent = '...';

        fetch(nextUrl + '&section_id=' + loadMoreBtn.dataset.sectionId)
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            var newItems = doc.querySelectorAll('.product-list__item');
            newItems.forEach(function(item) {
              productGrid.appendChild(item);
            });
            bindMobileAtc(productGrid);

            var nextBtn = doc.querySelector('.js-load-more');
            if (nextBtn && nextBtn.dataset.nextUrl) {
              loadMoreBtn.dataset.nextUrl = nextBtn.dataset.nextUrl;
              loadMoreBtn.disabled = false;
              loadMoreBtn.textContent = loadMoreLabel;
            } else {
              if (loadMoreWrap) loadMoreWrap.style.display = 'none';
            }

            syncCartState();
          })
          .catch(function() {
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = loadMoreLabel;
          });
      });
    }

    // ── Sort select ──
    var sortSelect = document.querySelector('.js-sort-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }

    // ── Mobile sort drawer ──
    var sortDrawer = document.getElementById('collection-sort-drawer');
    var sortBtn = document.getElementById('collection-sort-btn');
    var closeSortBtn = document.getElementById('collection-drawer-close-sort');

    function openSortDrawer() {
      if (!sortDrawer) return;
      sortDrawer.classList.add('is-open');
      sortDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeSortDrawer() {
      if (!sortDrawer) return;
      sortDrawer.classList.remove('is-open');
      sortDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    if (sortBtn) sortBtn.addEventListener('click', openSortDrawer);
    if (closeSortBtn) closeSortBtn.addEventListener('click', closeSortDrawer);
    if (sortDrawer) sortDrawer.addEventListener('click', function(e) {
      if (e.target === sortDrawer) closeSortDrawer();
    });

    // ── Mobile filter button ──
    var mobileFilterBtn = document.getElementById('collection-filter-btn');
    if (mobileFilterBtn) mobileFilterBtn.addEventListener('click', openFilterDrawer);

    // ── Filter drawer ──
    var filterDrawer = document.getElementById('collection-filter-drawer');

    function openFilterDrawer() {
      if (!filterDrawer) return;
      filterDrawer.classList.add('is-open');
      filterDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var btn = document.querySelector('.js-open-filter-drawer');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }

    function closeFilterDrawer() {
      if (!filterDrawer) return;
      filterDrawer.classList.remove('is-open');
      filterDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var btn = document.querySelector('.js-open-filter-drawer');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    document.querySelectorAll('.js-open-filter-drawer').forEach(function(btn) {
      btn.addEventListener('click', openFilterDrawer);
    });

    document.querySelectorAll('.js-close-filter-drawer').forEach(function(el) {
      el.addEventListener('click', closeFilterDrawer);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { closeFilterDrawer(); closeSortDrawer(); }
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCountdown(root) {
      var endDateStr = root.dataset.endDate;
      if (!endDateStr) return;

      var endDate = new Date(endDateStr).getTime();
      if (isNaN(endDate)) return;

      var id = root.id.replace('countdown-banner-', '');
      var timerEl = document.getElementById('countdown-timer-' + id);
      var expiredEl = document.getElementById('countdown-expired-' + id);
      var daysEl = root.querySelector('[data-unit="days"]');
      var hoursEl = root.querySelector('[data-unit="hours"]');
      var minutesEl = root.querySelector('[data-unit="minutes"]');
      var secondsEl = root.querySelector('[data-unit="seconds"]');

      function pad(num) {
        return String(num).padStart(2, '0');
      }

      function tick() {
        var now = Date.now();
        var diff = endDate - now;

        if (diff <= 0) {
          if (timerEl) timerEl.hidden = true;
          if (expiredEl) expiredEl.hidden = false;
          clearInterval(interval);
          return;
        }

        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        var minutes = Math.floor((diff / (1000 * 60)) % 60);
        var seconds = Math.floor((diff / 1000) % 60);

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      tick();
      var interval = setInterval(tick, 1000);
    }

    document.querySelectorAll('.countdown-banner').forEach(initCountdown);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function() {
    var toggles = document.querySelectorAll('.footer__accordion-toggle');
    toggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        var targetId = this.getAttribute('aria-controls');
        var list = document.getElementById(targetId);
        if (!list) return;
        this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        list.classList.toggle('is-open', !expanded);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var siteHeader = document.getElementById('site-header');
    var spacer = document.getElementById('site-header-spacer');
    var topbarWrap = siteHeader && siteHeader.querySelector('.site-header__topbar-wrap');
    var THRESHOLD = 10;

    /* ── Measure header bottom edge ── */
    function headerBottom() {
      return siteHeader ? siteHeader.getBoundingClientRect().bottom : 0;
    }

    /* ── Spacer: compensate for fixed header ── */
    function updateSpacer() {
      if (spacer && siteHeader) {
        var h = siteHeader.offsetHeight;
        if (h > 0) spacer.style.height = h + 'px';
      }
    }
    updateSpacer();
    document.addEventListener('DOMContentLoaded', updateSpacer);
    window.addEventListener('load', updateSpacer);
    window.addEventListener('resize', updateSpacer);
    if (topbarWrap) {
      topbarWrap.addEventListener('transitionend', function() {
        updateSpacer();
        updateMegaMenuTops();
      });
    }

    /* ── Mega menu: position fixed top = header bottom ── */
    function updateMegaMenuTops() {
      var bottom = headerBottom();
      document.querySelectorAll('.mega-menu').forEach(function(mm) {
        mm.style.top = bottom + 'px';
      });
    }
    updateMegaMenuTops();
    window.addEventListener('resize', updateMegaMenuTops);

    /* ── Mega menu: JS hover (CSS hover breaks with position:fixed detached menus) ── */
    document.querySelectorAll('.header-nav__item--mega').forEach(function(item) {
      var closeTimer = null;

      function openMenu() {
        clearTimeout(closeTimer);
        updateMegaMenuTops(); // ensure top is current before showing
        item.classList.add('is-open');
      }

      function scheduleClose() {
        closeTimer = setTimeout(function() {
          item.classList.remove('is-open');
        }, 80); // small delay so cursor can move into the mega menu
      }

      var megaMenu = item.querySelector('.mega-menu');

      item.addEventListener('mouseenter', openMenu);
      item.addEventListener('mouseleave', scheduleClose);

      if (megaMenu) {
        megaMenu.addEventListener('mouseenter', function() {
          clearTimeout(closeTimer);
        });
        megaMenu.addEventListener('mouseleave', scheduleClose);
      }
    });

    /* ── Scroll: hide topbar ── */
    function onScroll() {
      if (window.scrollY > THRESHOLD) {
        siteHeader.classList.add('is-scrolled');
      } else {
        siteHeader.classList.remove('is-scrolled');
      }
      updateSpacer();
      updateMegaMenuTops();
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    /* ── Mobile drawer ── */
   // Locate your mobile drawer block inside the layout function and update it to this:
var hamburger   = document.querySelector('.header-hamburger');
var drawer      = document.getElementById('mobile-nav-drawer');
var closeBtn    = document.querySelector('.mobile-nav-drawer__close');
var overlay     = document.querySelector('.mobile-nav-drawer__overlay');
var sliderTrack = document.getElementById('mobile-nav-track');

function openDrawer() {
  if (!drawer) return;
  // Reset placement back to Level 1 panel when opening the mobile menu drawer
  if (sliderTrack) {
    sliderTrack.style.transform = 'translateX(0%)';
    sliderTrack.setAttribute('data-current-level', '1');
  }
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeDrawer() {
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

if (hamburger) hamburger.addEventListener('click', openDrawer);
if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
if (overlay) overlay.addEventListener('click', closeDrawer);

// Forward Slide Interaction Logic
document.querySelectorAll('.mobile-slide-next-trigger').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    var nextPanelId = this.getAttribute('data-next-panel');
    var targetPanel = document.getElementById(nextPanelId);
    
    if (targetPanel) {
      var currentLevel = parseInt(sliderTrack.getAttribute('data-current-level') || '1', 10);
      var nextLevel = currentLevel + 1;
      
      // Toggle visibility states cleanly
      document.querySelectorAll('.mobile-nav-level--sub').forEach(function(p) {
        p.style.display = 'none';
      });
      targetPanel.style.display = 'block';
      
      if (sliderTrack) {
        var shiftAmount = (nextLevel - 1) * -100;
        sliderTrack.style.transform = 'translateX(' + shiftAmount + '%)';
        sliderTrack.setAttribute('data-current-level', nextLevel.toString());
      }
    }
  });
});

// Backward Reverse Slide Logic
document.querySelectorAll('.mobile-slide-back-trigger').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    var targetLevel = parseInt(this.getAttribute('data-back-to') || '1', 10);
    
    if (sliderTrack) {
      var shiftAmount = (targetLevel - 1) * -100;
      sliderTrack.style.transform = 'translateX(' + shiftAmount + '%)';
      sliderTrack.setAttribute('data-current-level', targetLevel.toString());
    }
  });
});

    /* ── Search overlay ── */
    var searchOverlay  = document.getElementById('header-search-overlay');
    var searchInput    = document.getElementById('header-search-input');
    var searchClear    = document.getElementById('header-search-clear');
    var searchBackdrop = document.getElementById('header-search-backdrop');
    var searchBtn      = document.querySelector('.header-icon-btn--search');
    var searchBtns     = document.querySelectorAll('.header-icon-btn--search');
    var searchResults  = document.getElementById('header-search-results');
    var suggestionsEl  = document.getElementById('header-search-suggestions');
    var productsEl     = document.getElementById('header-search-products');
    var viewAllEl      = document.getElementById('header-search-view-all');
    var predictiveTimer = null;

    function positionPanel() {
      /* no-op: panel is fixed at top:0 via CSS */
    }

    function openSearch() {
      if (!searchOverlay) return;
      positionPanel();
      searchOverlay.classList.add('is-open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (searchInput) { setTimeout(function() { searchInput.focus(); }, 50); }
    }

    function closeSearch() {
      if (!searchOverlay) return;
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (searchInput) searchInput.value = '';
      if (searchResults) searchResults.style.display = 'none';
    }

    /* Predictive search using Shopify /search/suggest.json */
    function renderSuggestions(queries, term) {
      if (!suggestionsEl) return;
      suggestionsEl.innerHTML = '';
      queries.slice(0, 6).forEach(function(q) {
        var li = document.createElement('li');
        var a  = document.createElement('a');
        a.href = '/search?type=product&q=' + encodeURIComponent(q.text);
        /* bold the part that matches the typed term */
        var label = q.text;
        var idx = label.toLowerCase().indexOf(term.toLowerCase());
        if (idx > -1) {
          var before = label.slice(0, idx);
          var match  = label.slice(idx, idx + term.length);
          var after  = label.slice(idx + term.length);
          a.innerHTML = (before ? escHtml(before) : '') +
                        '<strong>' + escHtml(match) + '</strong>' +
                        escHtml(after);
        } else {
          a.textContent = label;
        }
        li.appendChild(a);
        suggestionsEl.appendChild(li);
      });
    }

    function renderProducts(products) {
      if (!productsEl) return;
      productsEl.innerHTML = '';
      if (products.length === 0) {
        productsEl.innerHTML = '<p class="header-search-results__empty">No products found.</p>';
        return;
      }
      products.slice(0, 4).forEach(function(p) {
        var a = document.createElement('a');
        a.className = 'header-search-product';
        a.href = p.url;
        var imgHtml = p.featured_image && p.featured_image.url
          ? '<img class="header-search-product__img" src="' + p.featured_image.url + '&width=144" alt="' + escHtml(p.title) + '" width="72" height="88" loading="lazy">'
          : '<div class="header-search-product__img--placeholder"></div>';
        var priceRaw = p.price_min ? parseFloat(p.price_min) : 0;
        var price = priceRaw ? formatMoney(priceRaw * 100) : '';
        var compareRaw = p.compare_at_price_min ? parseFloat(p.compare_at_price_min) : 0;

         var priceHtml = '';
        if (priceRaw > 0) {
          var priceFormatted = formatMoney(priceRaw * 100);
          
          if (compareRaw > 0 && compareRaw > priceRaw) {
            var compareFormatted = formatMoney(compareRaw * 100);
            // Side-by-side single-line layout matching your product grids
            priceHtml = '<div class="product-grid__price-meta-row header">'
              + '<span class="product-page__price-current grid is-on-sale" style="font-size: 0.875rem !important;">' + priceFormatted + '</span>'
              + '<span class="product-page__price-compare" style="font-size: 12px !important;">' + compareFormatted + '</span>'
              + '</div>';
          } else {
            priceHtml = '<span class="header-search-product__price">' + priceFormatted + '</span>';
          }
        }
        a.innerHTML = imgHtml +
          '<div class="header-search-product__info">' +
            (p.vendor ? '<span class="header-search-product__vendor">' + escHtml(p.vendor) + '</span>' : '') +
            '<span class="header-search-product__title">' + escHtml(p.title) + '</span>' +
            priceHtml +
          '</div>';
        productsEl.appendChild(a);
      });
    }

    function formatMoney(cents) {
      var fmt = window.shopMoneyFormat || 'Rs. {{amount}}';
      var val = cents / 100;
      var amt   = val.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var amtNd = Math.floor(val).toLocaleString('en-IN');
      return fmt
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, amtNd)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amt)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amtNd)
        .replace(/\{\{\s*amount\s*\}\}/, amt);
    }

    function escHtml(str) {
      return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }

    function runPredictive(term) {
      if (!term || term.length < 2) {
        if (searchResults) searchResults.style.display = 'none';
        return;
      }
      var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
                '&resources[type]=product,query&resources[limit]=6' +
                '&resources[options][unavailable_products]=last' +
                '&resources[options][fields]=title,product_type,variants.title,vendor';
      fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var res        = data.resources && data.resources.results;
          var products   = ((res && res.products) || []).filter(function(p) {
            return !p.tags || p.tags.indexOf('Archived') === -1;
          });
          var queries    = (res && res.queries)     || [];
          renderSuggestions(queries, term);
          renderProducts(products);
          if (viewAllEl) {
            viewAllEl.textContent = 'SEARCH FOR "' + term.toUpperCase() + '"';
            viewAllEl.href = '/search?type=product&q=' + encodeURIComponent(term);
          }
          if (searchResults) searchResults.style.display = 'block';
        })
        .catch(function() {});
    }

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        var val = this.value.trim();
        /* clear button always visible — no toggle needed */
        clearTimeout(predictiveTimer);
        predictiveTimer = setTimeout(function() { runPredictive(val); }, 220);
      });
    }

    if (searchClear) {
      searchClear.addEventListener('click', function() {
        if (searchInput) { searchInput.value = ''; searchInput.focus(); }
        if (searchResults) searchResults.style.display = 'none';
      });
    }

    searchBtns.forEach(function(btn) { btn.addEventListener('click', openSearch); });
    if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);
    var searchCloseBtn = document.getElementById('header-search-close');
    if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);

    window.addEventListener('resize', positionPanel);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('is-open')) {
        closeSearch();
      }
    });
  })();

  /* ── Promo bar auto-scroll ── */
  (function() {
    var items = document.querySelectorAll('.header-promo-bar__item');
    if (items.length < 2) return;
    var current = 0;
    setInterval(function() {
      var next = (current + 1) % items.length;
      items[current].classList.add('is-exiting');
      items[current].classList.remove('is-active');
      items[next].classList.add('is-active');
      var exiting = items[current];
      setTimeout(function() { exiting.classList.remove('is-exiting'); }, 450);
      current = next;
    }, 3500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(sectionId) {
      var wrapper = document.getElementById('product-carousel-' + sectionId);
      var stage = wrapper ? wrapper.querySelector('.product-carousel__stage') : null;
      if (!stage) return;

      var cards = Array.from(stage.querySelectorAll('.product-carousel__card'));
      var total = cards.length;
      if (total === 0) return;

      var isReel = wrapper.hasAttribute('data-reel');
      var virtualIndex = 0;

      function getSizes(stageWidth) {
        var isMobile = stageWidth < 768;
        return isMobile
          ? [
              { w: 195, h: 310, opacity: 1,    z: 10 },
              { w: 140, h: 245, opacity: 0.9,  z: 8  },
              { w: 108, h: 195, opacity: 0.7,  z: 6  },
              { w: 85,  h: 160, opacity: 0.5,  z: 4  }
            ]
          : [
              { w: 355, h: 470, opacity: 1,    z: 10 },
              { w: 282, h: 405, opacity: 0.95, z: 8  },
              { w: 216, h: 350, opacity: 0.85, z: 6  },
              { w: 105, h: 310, opacity: 0.6,  z: 4  }
            ];
      }

      function render() {
        var stageWidth = stage.offsetWidth;
        var centerX = stageWidth / 2;
        var sizes = getSizes(stageWidth);
        var half = Math.floor(total / 2);

        var posMap = {};
        var centerSize = sizes[0];
        posMap[0] = { left: centerX - centerSize.w / 2, size: centerSize };

        var rightEdge = centerX + centerSize.w / 2;
        for (var r = 1; r <= half; r++) {
          var s = sizes[Math.min(r, sizes.length - 1)];
          posMap[r] = { left: rightEdge, size: s };
          rightEdge += s.w;
        }

        var leftEdge = centerX - centerSize.w / 2;
        for (var l = 1; l <= half; l++) {
          var sl = sizes[Math.min(l, sizes.length - 1)];
          posMap[-l] = { left: leftEdge - sl.w, size: sl };
          leftEdge -= sl.w;
        }

        cards.forEach(function (card, i) {
          var slot = ((i - virtualIndex) % total + total) % total;
          var offset = slot <= half ? slot : slot - total;
          var entry = posMap[offset];

          card.style.width     = entry.size.w + 'px';
          card.style.height    = entry.size.h + 'px';
          card.style.transform = 'translateX(' + entry.left + 'px) translateY(-50%)';
          card.style.opacity   = entry.size.opacity;
          card.style.zIndex    = entry.size.z;
          card.setAttribute('aria-current', slot === 0 ? 'true' : 'false');
        });

        if (isReel) updateVideoPlayback();
      }

      /* ── Reel video: only center card plays ── */
      function updateVideoPlayback() {
        cards.forEach(function (card, i) {
          var slot = ((i - virtualIndex) % total + total) % total;
          var video = card.querySelector('.product-carousel__card-video');
          if (!video) return;

          if (slot === 0) {
            card.setAttribute('data-playing', 'true');
            var playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(function() {});
            }
          } else {
            card.removeAttribute('data-playing');
            video.pause();
            video.currentTime = 0;
          }
        });
      }

      function next() {
        virtualIndex = (virtualIndex + 1) % total;
        render();
      }

      function prev() {
        virtualIndex = (virtualIndex - 1 + total) % total;
        render();
      }

      cards.forEach(function (card, i) {
        card.addEventListener('click', function (e) {
          var slot = ((i - virtualIndex) % total + total) % total;
          if (slot === 0) return;
          e.preventDefault();
          virtualIndex = (virtualIndex + slot) % total;
          render();
          resetAutoplay();
        });
      });

      var prevBtn = document.getElementById('pc-prev-' + sectionId);
      var nextBtn = document.getElementById('pc-next-' + sectionId);
      var autoplayTimer = null;

      /* Reel mode: no autoplay — user controls the carousel.
         Product/collection mode: autoplay every 3s. */
      function startAutoplay() {
        if (isReel) return;
        autoplayTimer = setInterval(next, 3000);
      }

      function resetAutoplay() {
        clearInterval(autoplayTimer);
        startAutoplay();
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetAutoplay(); });

      if (!isReel) {
        stage.addEventListener('mouseenter', function () { clearInterval(autoplayTimer); });
        stage.addEventListener('mouseleave', startAutoplay);
      }

      var touchStartX = 0;
      stage.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 40) return;
        if (diff > 0) { next(); } else { prev(); }
        resetAutoplay();
      }, { passive: true });

      render();
      startAutoplay();
      window.addEventListener('resize', render);
    }

    document.querySelectorAll('[id^="product-carousel-"]').forEach(function (el) {
      var id = el.id.replace('product-carousel-', '');
      initCarousel(id);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initScrollIndicator(sectionId) {
      var grid = document.getElementById('product-list-grid-' + sectionId);
      var indicator = document.getElementById('product-list-indicator-' + sectionId);
      if (!grid || !indicator) return;

      var bars = indicator.querySelectorAll('.product-list__scroll-bar');
      if (!bars.length) return;

      function updateIndicator() {
        var scrollLeft = grid.parentElement.scrollLeft;
        var scrollWidth = grid.parentElement.scrollWidth - grid.parentElement.clientWidth;
        var progress = scrollWidth > 0 ? scrollLeft / scrollWidth : 0;
        var activeIndex = Math.round(progress * (bars.length - 1));

        bars.forEach(function(bar, i) {
          bar.classList.toggle('is-active', i === activeIndex);
        });
      }

      grid.parentElement.addEventListener('scroll', updateIndicator, { passive: true });
      updateIndicator();
    }

    document.querySelectorAll('.product-list').forEach(function(section) {
      var id = section.querySelector('[id^="product-list-grid-"]');
      if (!id) return;
      var sectionId = id.id.replace('product-list-grid-', '');
      initScrollIndicator(sectionId);
    });

    var cartVariantIds = [];

    function syncCartState() {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          cartVariantIds = cart.items.map(function(i) { return String(i.variant_id); });
          document.querySelectorAll('.product-list__item[data-variant-id]').forEach(function(card) {
            var variantId = card.dataset.variantId;
            var inCart = cartVariantIds.indexOf(variantId) !== -1;
            var iconBtn = card.querySelector('.product-card-actions__btn--cart');
            var mobileBtn = card.querySelector('.product-card-mobile-bar__cart');
            if (iconBtn) iconBtn.classList.toggle('is-added', inCart);
            if (mobileBtn) {
              mobileBtn.classList.toggle('is-added', inCart);
              if (inCart) mobileBtn.textContent = 'ADDED TO CART';
              else mobileBtn.textContent = 'ADD TO CART';
            }
          });
        });
    }

    // Mobile ATC button — submits the hidden form outside the <a>
    document.querySelectorAll('.product-list__item').forEach(function(card) {
      var mobileAtcBtn = card.querySelector('.js-mobile-atc');
      if (!mobileAtcBtn) return;
      mobileAtcBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var hiddenForm = card.querySelector('.product-card-atc-form--mobile');
        if (hiddenForm) hiddenForm.querySelector('[type="submit"]').click();
      });
    });

    document.addEventListener('cart:refresh', syncCartState);

    syncCartState();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function() {
    function applyCardState(card) {
      var variantId = card.dataset.variantId;
      var isAvailable = card.dataset.available === 'true';
      var iconBtn = card.querySelector('.product-card-actions__btn--cart');
      var mobileBtn = card.querySelector('.product-card-mobile-bar__cart');
      if (!isAvailable) {
        if (iconBtn) { iconBtn.disabled = true; }
        if (mobileBtn) { mobileBtn.disabled = true; mobileBtn.textContent = 'OUT OF STOCK'; mobileBtn.classList.add('product-card-mobile-bar__cart--soldout'); }
      }
    }

    document.querySelectorAll('.search-page .product-list__item[data-variant-id]').forEach(applyCardState);

    document.querySelectorAll('.search-page .js-cart-toggle').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('.product-list__item');
        var variantId = card && card.dataset.variantId;
        if (!variantId) return;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          var iconBtn = card.querySelector('.product-card-actions__btn--cart');
          var mobileBtn = card.querySelector('.product-card-mobile-bar__cart');
          if (iconBtn) { iconBtn.classList.add('is-added'); }
          if (mobileBtn) { mobileBtn.textContent = 'ADDED TO CART'; mobileBtn.classList.add('is-added'); }
          setTimeout(function() {
            if (iconBtn) { iconBtn.classList.remove('is-added'); }
            if (mobileBtn) { mobileBtn.textContent = 'ADD TO CART'; mobileBtn.classList.remove('is-added'); }
          }, 2000);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stores"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    /* ── Desktop accordion ── */
    var panels = document.querySelectorAll('.stores__panels--desktop .stores__panel');
    panels.forEach(function (panel) {
      panel.addEventListener('click', function () {
        var siblings = panel.closest('.stores__panels--desktop').querySelectorAll('.stores__panel');
        siblings.forEach(function (s) { s.classList.remove('is-active'); });
        panel.classList.add('is-active');
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          panel.click();
        }
      });
    });

    /* ── Mobile slider ── */
    var mobile = document.querySelector('.stores__mobile--hidden');
    if (!mobile) return;

    var track = mobile.querySelector('.stores__slider-track');
    var tabs = mobile.querySelectorAll('.stores__tab');
    var bars = mobile.querySelectorAll('.stores__progress-bar');
    var currentIndex = 0;

    function goTo(index) {
      currentIndex = index;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      tabs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      bars.forEach(function (b, i) {
        b.classList.toggle('is-active', i === index);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        goTo(parseInt(tab.dataset.index));
      });
    });

    /* Swipe support */
    var touchStartX = 0;
    var touchEndX = 0;
    var slideCount = tabs.length;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].clientX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 40) {
        if (diff > 0 && currentIndex < slideCount - 1) {
          goTo(currentIndex + 1);
        } else if (diff < 0 && currentIndex > 0) {
          goTo(currentIndex - 1);
        }
      }
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-product-list"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initTabList(section) {
      var tabsContainer = section.querySelector('.tab-product-list__tabs');
      var tabs = section.querySelectorAll('.tab-product-list__tab');
      var panels = section.querySelectorAll('.tab-product-list__panel');
      var indicator = section.querySelector('.tab-product-list__tab-indicator');

      if (!tabs.length || !indicator) return;

      function positionIndicator(tab) {
        var containerLeft = tabsContainer.getBoundingClientRect().left;
        var tabLeft = tab.getBoundingClientRect().left;
        indicator.style.left = (tabLeft - containerLeft) + 'px';
        indicator.style.width = tab.offsetWidth + 'px';
      }

      function activateTab(index) {
        tabs.forEach(function(t, i) {
          t.classList.toggle('is-active', i === index);
          t.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        panels.forEach(function(p, i) {
          p.classList.toggle('is-active', i === index);
          p.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        positionIndicator(tabs[index]);
      }

      tabs.forEach(function(tab, i) {
        tab.addEventListener('click', function() { activateTab(i); });
      });

      // Wait for layout before setting initial indicator position
      requestAnimationFrame(function() {
        positionIndicator(tabs[0]);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('.tab-product-list').forEach(initTabList);
      });
    } else {
      document.querySelectorAll('.tab-product-list').forEach(initTabList);
    }

    var tabCartVariantIds = [];

    function syncTabCartState() {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          tabCartVariantIds = cart.items.map(function(i) { return String(i.variant_id); });
          document.querySelectorAll('.tab-product-list__item[data-variant-id]').forEach(applyTabCardState);
        });
    }

    function applyTabCardState(card) {
      var variantId = card.dataset.variantId;
      var available = card.dataset.available === 'true';
      var inCart = tabCartVariantIds.indexOf(variantId) !== -1;

      var iconBtn = card.querySelector('.product-card-actions__btn--cart');
      var tooltip = card.querySelector('.js-cart-tooltip');
      var mobileBtn = card.querySelector('.product-card-mobile-bar__cart');

      if (!available) {
        if (mobileBtn) {
          mobileBtn.disabled = true;
          mobileBtn.textContent = 'OUT OF STOCK';
          mobileBtn.classList.add('product-card-mobile-bar__cart--soldout');
          mobileBtn.classList.remove('is-added');
        }
        return;
      }

      if (inCart) {
        if (iconBtn) { iconBtn.classList.add('is-added'); iconBtn.disabled = false; }
        if (tooltip) tooltip.textContent = 'Remove from cart';
        if (mobileBtn) {
          mobileBtn.textContent = 'ADDED TO CART';
          mobileBtn.classList.add('is-added');
          mobileBtn.classList.remove('product-card-mobile-bar__cart--soldout');
          mobileBtn.disabled = false;
        }
      } else {
        if (iconBtn) { iconBtn.classList.remove('is-added'); iconBtn.disabled = false; }
        if (tooltip) tooltip.textContent = 'Add to cart';
        if (mobileBtn) {
          mobileBtn.textContent = 'ADD TO CART';
          mobileBtn.classList.remove('is-added', 'product-card-mobile-bar__cart--soldout');
          mobileBtn.disabled = false;
        }
      }
    }

    function addToTabCart(variantId, btn) {
      btn.disabled = true;
      var drawer = document.querySelector('cart-drawer');
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.id) {
          tabCartVariantIds.push(String(variantId));
          var card = document.querySelector('.tab-product-list__item[data-variant-id="' + variantId + '"]');
          if (card) applyTabCardState(card);
          return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            if (drawer) { drawer.renderCart(cart); drawer.open(); }
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          });
        }
        btn.disabled = false;
      })
      .catch(function() { btn.disabled = false; })
      .finally(function() { btn.disabled = false; });
    }

    function removeFromTabCart(variantId, btn) {
      btn.disabled = true;
      var drawer = document.querySelector('cart-drawer');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var idx = tabCartVariantIds.indexOf(String(variantId));
        if (idx !== -1) tabCartVariantIds.splice(idx, 1);
        var card = document.querySelector('.tab-product-list__item[data-variant-id="' + variantId + '"]');
        if (card) applyTabCardState(card);
        if (drawer) drawer.renderCart(cart);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function() { btn.disabled = false; });
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.tab-product-list .js-cart-toggle');
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest('[data-variant-id]');
      if (!card || card.dataset.available === 'false') return;
      var variantId = card.dataset.variantId;
      var inCart = tabCartVariantIds.indexOf(variantId) !== -1;
      if (inCart) {
        removeFromTabCart(variantId, btn);
      } else {
        addToTabCart(variantId, btn);
      }
    });

    document.addEventListener('cart:refresh', syncTabCartState);

    // Mobile ATC button — submits the hidden form outside the <a>
    document.querySelectorAll('.tab-product-list__item').forEach(function(card) {
      var mobileAtcBtn = card.querySelector('.js-mobile-atc');
      if (!mobileAtcBtn) return;
      mobileAtcBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var hiddenForm = card.querySelector('.product-card-atc-form--mobile');
        if (hiddenForm) hiddenForm.querySelector('[type="submit"]').click();
      });
    });

    syncTabCartState();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ── Video modal ── */
    var modal  = document.getElementById('testimonials-modal');
    var player = document.getElementById('testimonials-player');

    function openModal(url, type) {
      if (!modal || !player) return;
      player.innerHTML = '';
      if (type === 'video' || (!url.includes('youtube') && !url.includes('youtu.be') && !url.includes('vimeo'))) {
        var vid = document.createElement('video');
        vid.src = url;
        vid.controls = true;
        vid.autoplay = true;
        vid.style.width = '100%';
        vid.style.height = '100%';
        player.appendChild(vid);
      } else {
        var src = url;
        if (url.includes('youtu.be/')) {
          src = 'https://www.youtube.com/embed/' + url.split('youtu.be/')[1].split('?')[0] + '?autoplay=1';
        } else if (url.includes('youtube.com/watch')) {
          var id = url.split('v=')[1];
          if (id) id = id.split('&')[0];
          src = 'https://www.youtube.com/embed/' + id + '?autoplay=1';
        } else if (url.includes('vimeo.com/')) {
          var vid_id = url.split('vimeo.com/')[1].split('?')[0];
          src = 'https://player.vimeo.com/video/' + vid_id + '?autoplay=1';
        }
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.allow = 'autoplay; fullscreen';
        iframe.allowFullscreen = true;
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        player.appendChild(iframe);
      }
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (player) player.innerHTML = '';
      document.body.style.overflow = '';
    }

    document.querySelectorAll('.js-video-trigger').forEach(function(el) {
      el.addEventListener('click', function() {
        var url  = el.dataset.videoUrl;
        var type = el.dataset.videoType;
        if (url) openModal(url, type);
      });
    });

    document.querySelectorAll('.js-modal-close').forEach(function(el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeModal();
    });

    /* ── Extract Judge.me reviews and render custom marquee ── */
    function extractJudgemeReviews() {
      var widget = document.querySelector('.jdgm-cards-carousel');
      if (!widget) return [];

      var cards = widget.querySelectorAll('.jdgm-card:not(.jdgm-clone-before):not(.jdgm-clone-after)');
      var reviews = [];
      var seen = {};

      cards.forEach(function(card) {
        var id = card.getAttribute('data-review-id');
        if (!id || seen[id]) return;
        seen[id] = true;

        var nameEl = card.querySelector('.jdgm-reviewer-name');
        var textEl = card.querySelector('.jdgm-text');
        var starsOn = card.querySelectorAll('.jdgm-star.jdgm--on').length;

        var name = nameEl ? nameEl.textContent.trim() : 'Anonymous';
        var text = textEl ? textEl.textContent.trim() : '';
        if (text.length > 150) text = text.substring(0, 150) + '…';

        reviews.push({ name: name, text: text, rating: starsOn || 5 });
      });

      return reviews;
    }

    function buildMarqueeCards(reviews) {
      var html = '';
      reviews.forEach(function(r) {
        var initial = r.name.charAt(0).toUpperCase();
        var stars = '';
        for (var i = 1; i <= 5; i++) {
          var fill = i <= r.rating ? '#f59e0b' : '#d1d5db';
          stars += '<svg viewBox="0 0 16 16" fill="' + fill + '" width="16" height="16" aria-hidden="true"><path d="M8 1.139l1.854 3.756 4.146.603-3 2.924.708 4.128L8 10.412l-3.708 1.138.708-4.128-3-2.924 4.146-.603z"/></svg>';
        }

        html += '<div class="testimonials__review-card">';
        html += '<div class="testimonials__reviewer">';
        html += '<div class="testimonials__avatar">' + initial + '</div>';
        html += '<div class="testimonials__reviewer-info">';
        html += '<span class="testimonials__reviewer-name">' + escapeHtml(r.name) + '</span>';
        html += '</div></div>';
        html += '<div class="testimonials__stars" aria-label="' + r.rating + ' out of 5 stars">' + stars + '</div>';
        if (r.text) html += '<p class="testimonials__review-text">"' + escapeHtml(r.text) + '"</p>';
        html += '</div>';
      });
      return html;
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    function initMarquee() {
      var reviews = extractJudgemeReviews();
      if (reviews.length === 0) return false;

      var sections = document.querySelectorAll('.testimonials[data-section-id]');
      sections.forEach(function(section) {
        var sectionId = section.dataset.sectionId;
        var track1 = document.getElementById('testimonials-track-1-' + sectionId);
        var track2 = document.getElementById('testimonials-track-2-' + sectionId);
        var wrap = document.getElementById('testimonials-marquee-' + sectionId);
        var marqueeInner = document.getElementById('testimonials-marquee-inner-' + sectionId);

        if (!track1 || !track2) return;

        var html = buildMarqueeCards(reviews);
        track1.innerHTML = html;
        track2.innerHTML = html;

        if (wrap) wrap.setAttribute('data-loaded', 'true');
        var duration = Math.max(20, reviews.length * 5);
        if (marqueeInner) marqueeInner.style.setProperty('--marquee-duration', duration + 's');
      });

      return true;
    }

    /* Poll until Judge.me renders its cards */
    var attempts = 0;
    var pollInterval = setInterval(function() {
      attempts++;
      if (initMarquee() || attempts > 60) {
        clearInterval(pollInterval);
        if (attempts > 60) {
          document.querySelectorAll('.testimonials__loading-text').forEach(function(el) {
            el.textContent = 'No reviews available.';
          });
        }
      }
    }, 500);

  })();

  } catch(e) { console.error(e); }
})();
})();
